export default (() => {
  window.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".room-slider")) {
      import("bxslider/dist/jquery.bxslider").then(() => {
        const slider = $(".room-slider").bxSlider({
          auto: 1,
          mode: "fade",
          speed: 1e3,
          pause: 6500,
          infiniteLopp: true,
          controls: false,
          nextText: "",
          prevText: "",
          touchEnabled: false
        });
        $(".previous-slide-main-left").on("click", () => {
          slider.goToPrevSlide();
          return false;
        });
        $(".next-slide-main-left").on("click", () => {
          slider.goToNextSlide();
          return false;
        });
      });
    }
  });
})();